import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axios } from '../../config/axios';
import { QUERY_KEYS } from '../../constants/queryKeys.const';
import { Order } from '../../types/order.types';

export const useCancelOrder = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async (id: number): Promise<Order> => axios.delete(`orders/${id}`),
    {
      onSuccess: () => queryClient.invalidateQueries([QUERY_KEYS.GET_ORDERS]),
    },
  );
};
